import { render, staticRenderFns } from "./HoverLinkCard.vue?vue&type=template&id=fb084086&scoped=true&"
import script from "./HoverLinkCard.vue?vue&type=script&lang=ts&"
export * from "./HoverLinkCard.vue?vue&type=script&lang=ts&"
import style0 from "./HoverLinkCard.vue?vue&type=style&index=0&id=fb084086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb084086",
  null
  
)

export default component.exports